export enum LoginProvider {
  Cxm = 'cxm',
  Google = 'google',
  Tiendanube = 'tiendanube',
}
